import * as React from 'react';

/**
 * @description Facebook icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Facebook } from '@sravni/design-system-icons'
 *
 * <Facebook />
 * ```
 */
const Facebook = React.forwardRef((props, ref) => (React.createElement("svg", { ref: ref, "data-qa": "Facebook", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props },
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.761 10.477c.044.054.02.431.02.502L7.782 18h3.528c.02-2.094 0-3.309 0-5.412 0-.031-.007-2.038.003-2.08.02-.035 2.26-.018 2.337-.036l.039-.011.31-2.904h-2.678c-.01-.429.002-.87.003-1.3 0-.392-.01-.878.23-1.092l2.43-.24-.003-2.912c-.46-.027-1.005-.003-1.475-.003-.489 0-.983-.01-1.464.021-.916.06-1.655.327-2.19.772-.775 1.215-1.074.172-1.08 4.755H6l.004 2.917 1.757.002Z", fill: "currentColor" }))));

export { Facebook };
//# sourceMappingURL=Facebook.js.map
